// extracted by mini-css-extract-plugin
module.exports = {"specialty":"styles-module__specialty___oOibc","content":"styles-module__content___2SlLk"};